(ns admin.events.containers.curriculum-settings
  "Responsible for bootstrapping the new-curriclum & edit-curriculum settings pages."
  (:require [kyber.router :refer [ensure-resource-v2]]
            [kyber.events.eql :as eql]
            [kyber.events.utils :refer [kyber-event-fx]]
            [re-frame.core :as re-frame]
            [kyber.lib.kyber-db :as kyber-db]))

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-success
    {:description "Get curriculum settings page (Success)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-success
  [{:keys [db]} [event-name {:keys [curriculum-uuid]} res]]
  (let [curriculum (get res [:curriculum/uuid curriculum-uuid])
        content-provider (get res :app.current-session/content-provider)]
    {:db (cond-> (kyber-db/tx-record db {:model :content-provider} content-provider)
           (some? curriculum) (kyber-db/tx-record  {:model :curriculum} curriculum))
     :dispatch-n [[:analytics/save-datapoint {:event event-name
                                              :event-version 0}]]}))

(kyber-event-fx ::fetch-container-data-success fetch-container-data-success)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data-failure
    {:description "Get curriculum settings page (Failure)"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data-failure
  [{:keys [db]} [event-name _ _err]]
  {:db db
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]})

(kyber-event-fx ::fetch-container-data-failure fetch-container-data-failure)

(when ^boolean js/goog.DEBUG
  (def event-doc-fetch-container-data
    {:description "Get curriculum settings page"
     :changelog
     [{:date "21JAN21"
       :event-version 0
       :data {}}]}))

(defn fetch-container-data
  [{:keys [db]} [event-name {:keys [curriculum-uuid] :as params}]]
  {:db (cond-> db
         (some? curriculum-uuid)
         (kyber-db/retract-record {:model :curriculum} {:curriculum/uuid curriculum-uuid}))
   :dispatch-n [[:analytics/save-datapoint {:event event-name
                                            :event-version 0}]]
   :request
   (eql/request
    db
    {:name event-name
     :params (cond-> [{:app.current-session/content-provider
                       [:content-provider/uuid
                        {:content-provider/tag-groups
                         [:content-provider.tag-group/uuid
                          :content-provider.tag-group/name
                          :content-provider.tag-group/description
                          {:content-provider.tag-group/values
                           [:content-provider.tag/uuid
                            :content-provider.tag/name]}]}]}]
               (some? curriculum-uuid)
               (conj {[:curriculum/uuid curriculum-uuid]
                      [:curriculum/uuid
                       :curriculum/name
                       :curriculum/description
                       :curriculum/clp-enabled
                       :curriculum/clp-banner
                       :curriculum/compliance-enabled
                       :curriculum/enforce-activity-order
                       :curriculum/max-number-of-activities
                       :curriculum/logo
                       :curriculum/pre-registration-enabled?
                       :curriculum/participant-id-required
                       :curriculum/participant-id-label
                       :curriculum/self-reg-require-name
                       {:curriculum/valid-tags
                        [:content-provider.tag-group/uuid
                         :content-provider.tag-group/name
                         :content-provider.tag-group/description
                         {:content-provider.tag-group/values
                          [:content-provider.tag/uuid
                           :content-provider.tag/name]}]}
                       {:curriculum/intro-activity [:activity/uuid
                                                    :activity/name]}
                       {:curriculum/activities [:activity/uuid
                                                :activity/name
                                                :activity/is-supplemental?
                                                {:activity/valid-tags
                                                 [:content-provider.tag-group/uuid
                                                  :content-provider.tag-group/name
                                                  :content-provider.tag-group/description
                                                  {:content-provider.tag-group/values
                                                   [:content-provider.tag/uuid
                                                    :content-provider.tag/name]}]}]}]}))
     :on-success [::fetch-container-data-success params]
     :on-failure [::fetch-container-data-failure params]})})

(kyber-event-fx ::fetch-container-data fetch-container-data)

(def ensure-curriculum-settings
  ""
  (partial ensure-resource-v2
           ::fetch-container-data
           #(re-frame/dispatch [::fetch-container-data %])))
